import React, { useState } from 'react';
import { FiClipboard } from 'react-icons/fi';

import { Skeleton } from '@material-ui/lab';
import { PieChart, Pie as RechartsPie, Sector, Cell } from 'recharts';

import { Container, InformationContainer } from './styles';

interface IDataChart {
  name: string;
  value: number;
  color: string;
}

interface Props {
  data: IDataChart[];
  loading: boolean;
}

const renderActiveShape = (props: {
  cx: any;
  cy: any;
  midAngle: any;
  innerRadius: any;
  outerRadius: any;
  startAngle: any;
  endAngle: any;
  fill: any;
  payload: any;
  percent: any;
  value: any;
  name: any;
}) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    percent,
    name,
    value,
    payload,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 10) * cos;
  const my = cy + (outerRadius + 20) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <svg overflow="auto">
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <text x={cx} y={cy + 20} dy={8} textAnchor="middle" fill={fill}>
        {value === 1 ? `${payload.value} tarefa` : `${payload.value} tarefas`}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >
        {`${name}`}
      </text>

      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </svg>
  );
};

const Pie: React.FC<Props> = ({ data, loading }) => {
  const [activeIndex, setActiveIndex] = useState<any>(0);
  const onPieEnter = (_data: any, index: any) => {
    setActiveIndex(index);
  };

  const hasData = () => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < data.length; i++) {
      if (data[i].value > 0) return true;
    }
    return false;
  };

  return (
    <Container>
      {!loading ? (
        hasData() ? (
          <>
            <PieChart width={500} height={380}>
              <RechartsPie
                activeIndex={!loading ? [activeIndex] : [0]}
                activeShape={renderActiveShape}
                data={data}
                cx={240}
                cy={170}
                innerRadius={95}
                outerRadius={115}
                fill="#8884d8"
                dataKey="value"
                minAngle={3}
                paddingAngle={2}
                onMouseEnter={onPieEnter}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={data[index].color} />
                ))}
              </RechartsPie>
            </PieChart>
          </>
        ) : (
          <InformationContainer>
            <FiClipboard size={50} color="rgb(108, 108, 108)" />
            <h1>Nenhuma tarefa encontrada</h1>
          </InformationContainer>
        )
      ) : (
        <Skeleton animation="wave" variant="circle" height={240} width={240} />
      )}
    </Container>
  );
};

export default Pie;
